  import firebase from 'firebase/app';
  import 'firebase/firestore';
  import 'firebase/auth';
  
  // Your web app's Firebase configuration
  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
  var firebaseConfig = {
    apiKey: 'AIzaSyCCviE3i58uaSao6T_ZiZ6tf2ZX4X0U0sY',
    authDomain: 'the-cookbook-2021.firebaseapp.com',
    projectId: 'the-cookbook-2021',
    storageBucket: 'the-cookbook-2021.appspot.com',
    messagingSenderId: '1093656775108',
    appId: '1:1093656775108:web:82575e3a0cb2d475153c91',
    measurementId: 'G-DRWE73E3NT'
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  // firebase.analytics();
  firebase.firestore().settings({ timestampsInSnapshots: true });

  export default firebase;